














import { Vue, Component } from 'vue-property-decorator';
import StatsSidebar from '@/views/statistics/sidebar.vue';

@Component({
  components: {
    StatsSidebar,
  },
})
export default class StatsLayout extends Vue {
  mounted() {
    const userToken = localStorage.getItem('ACCESS_TOKEN');
    localStorage.clear();
    if (userToken) {
      localStorage.setItem('ACCESS_TOKEN', userToken);
    }
  }
}
